<template>
  <div class="customer-info-form">
    <p class="intro-text body20-light mb-4">{{ $t('customer.form_intro') }}</p>

    <!-- Riga: Titolo, Nome, Cognome -->
    <div class="row g-2 mb-3">
      <div class="col-12 col-md-2">
        <div class="form-group required">
          <label for="customer-title" class="form-label legend16-bold">{{ $t('customer.title') }}</label>
          <div class="select-wrapper">
            <select id="customer-title" class="form-select" v-model="customerData.title">
              <option value="Mr.">{{ $t('customer.mr') }}</option>
              <option value="Mrs.">{{ $t('customer.mrs') }}</option>
              <option value="Ms.">{{ $t('customer.ms') }}</option>
              <option value="Ms.">{{ $t('customer.miss') }}</option>
              <option value="Ms.">{{ $t('customer.dr') }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-5">
        <div class="form-group required">
          <label for="customer-first-name" class="form-label legend16-bold">{{ $t('customer.first_name') }}</label>
          <input id="customer-first-name" class="form-control body20-bold" type="text" v-model="customerData.firstName"
            required />
        </div>
      </div>

      <div class="col-12 col-md-5">
        <div class="form-group required">
          <label for="customer-last-name" class="form-label legend16-bold">{{ $t('customer.last_name') }}</label>
          <input id="customer-last-name" class="form-control body20-bold" type="text" v-model="customerData.lastName"
            required />
        </div>
      </div>
    </div>

    <!-- Email -->
    <div class="mb-3">
      <div class="form-group required">
        <label for="customer-email" class="form-label legend16-bold">{{ $t('customer.email') }}</label>
        <input id="customer-email" class="form-control body20-bold" type="email" v-model="customerData.email"
          required />
      </div>
    </div>

    <!-- Riga: Prefisso e Telefono -->
    <div class="row g-2 mb-3">
      <div class="col-4">
        <div class="form-group">
          <label for="customer-phone-code" class="form-label legend16-bold">{{ $t('customer.phone_code') }}</label>
          <div class="select-wrapper">
            <select id="customer-phone-code" class="form-select" v-model="customerData.phoneCode">
              <option value="+39">+39</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-8">
        <div class="form-group required">
          <label for="customer-phone" class="form-label legend16-bold">{{ $t('customer.phone') }}</label>
          <input id="customer-phone" class="form-control body20-bold" type="tel" v-model="customerData.phone"
            @input="handlePhoneInput" inputmode="numeric" pattern="[0-9]*" required />
        </div>
      </div>
    </div>

    <!-- Paese -->
    <div class="mb-3">
      <div class="form-group">
        <label for="customer-country" class="form-label legend16-bold">{{ $t('customer.country') }}</label>
        <div class="select-wrapper">
          <select id="customer-country" class="form-select" v-model="customerData.country">
            <option v-for="country in countries" :key="country.code" :value="country.name">
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Città -->
    <div class="mb-3">
      <div class="form-group">
        <label for="customer-city" class="form-label legend16-bold">{{ $t('customer.city') }}</label>
        <input id="customer-city" class="form-control body20-bold" type="text" v-model="customerData.city" />
      </div>
    </div>

    <!-- Note -->
    <div class="mb-3">
      <div class="form-group">
        <label for="customer-notes" class="form-label legend16-bold">{{ $t('customer.notes') }}</label>
        <textarea id="customer-notes" class="form-control body20-bold" rows="3" maxlength="500"
          v-model="customerData.notes"></textarea>
      </div>
    </div>

    <!-- Nota campi obbligatori -->
    <p class="legend14-light mandatory-notice mb-3">
      {{ $t('customer.mandatory_informations') }}
    </p>

    <!-- Checkbox termini e privacy -->
    <div class="form-check checkbox-wrapper">
      <input id="terms-checkbox" class="form-check-input" type="checkbox" v-model="customerData.termsAccepted"
        required />
      <label for="terms-checkbox" class="form-check-label legend14-bold" v-html="$t('customer.terms_privacy_accept', {
        terms_link: `<a href='${termsConditionsLink}' target='_blank'>${$t('customer.terms_conditions')}</a>`,
        privacy_link: `<a href='${privacyPolicyLink}' target='_blank'>${$t('customer.privacy_policy')}</a>`
      })"></label>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerInfoForm",

  props: {
    currentAppointment: {
      type: Object,
      default: null,
    },
  },

  data () {
    return {
      customerData: {
        title: "Mr.",
        firstName: "",
        lastName: "",
        email: "",
        phoneCode: "+39",
        phone: "",
        country: this.$t('countries.it'),
        city: "",
        notes: "",
        termsAccepted: false,
      },
      countries: this.getCountriesList(),
      // Utilizza i link configurati o un valore di fallback
      termsConditionsLink: window.rolexCalendarSettings
        ? window.rolexCalendarSettings.terms_conditions_link
        : "#",
      privacyPolicyLink: window.rolexCalendarSettings
        ? window.rolexCalendarSettings.privacy_policy_link
        : "#",
    };
  },

  computed: {
    isValid () {
      const result =
        !!this.customerData.firstName &&
        !!this.customerData.lastName &&
        !!this.customerData.email &&
        !!this.customerData.phone &&
        !!this.customerData.termsAccepted;

      return result;
    },

    customerInfo () {
      return {
        title: this.customerData.title,
        firstName: this.customerData.firstName,
        lastName: this.customerData.lastName,
        email: this.customerData.email,
        phoneCode: this.customerData.phoneCode,
        phone: this.customerData.phone,
        country: this.customerData.country,
        city: this.customerData.city,
        notes: this.customerData.notes,
        termsAccepted: this.customerData.termsAccepted
      };
    },
  },

  watch: {
    customerData: {
      handler () {
        // Controlla la validità ogni volta che i dati cambiano
        this.$nextTick(this.checkFormValidity);
      },
      deep: true,
    },
    currentAppointment: {
      handler: "initializeFromCurrentAppointment",
      immediate: true,
    },
  },

  created () {
    this.initializeFromCurrentAppointment();
  },

  methods: {
    handlePhoneInput (event) {
      // Rimuovi tutti i caratteri non numerici
      const value = event.target.value.replace(/[^0-9]/g, '');
      this.customerData.phone = value;
    },

    getCountriesList () {
      // Crea una lista di paesi dinamicamente usando le traduzioni
      return [
        { code: "IT", name: this.$t('countries.it') },
        { code: "CH", name: this.$t('countries.ch') },
        { code: "FR", name: this.$t('countries.fr') },
        { code: "DE", name: this.$t('countries.de') },
        { code: "UK", name: this.$t('countries.uk') },
        { code: "ES", name: this.$t('countries.es') }
        // Altri paesi possono essere aggiunti qui se necessario
      ];
    },

    initializeFromCurrentAppointment () {
      if (this.currentAppointment && this.currentAppointment.customer) {
        // Estrai le informazioni del cliente dall'appuntamento
        this.extractCustomerDataFromAppointment();

        // Controlla la validità del form dopo l'inizializzazione
        this.$nextTick(this.checkFormValidity);
      }
    },

    extractCustomerDataFromAppointment () {
      const appointment = this.currentAppointment;

      // Aggiorna i dati del cliente
      this.customerData = {
        ...this.customerData,
        title: appointment.customer.title,
        firstName: appointment.customer.first_name,
        lastName: appointment.customer.last_name,
        email: appointment.customer.email || "",
        phoneCode: appointment.customer.phoneCode,
        phone: appointment.customer.phone,
        country: appointment.customer.country || this.$t('countries.it'),
        city: appointment.customer.city || "",
        notes: appointment.customer.notes || "",
        termsAccepted: appointment.customer.termsAccepted == 1
      };
    },

    getCustomerInfo () {
      // Verifica la validità prima di restituire i dati
      const valid = this.checkFormValidity();

      if (valid) {
        return this.customerInfo;
      }
      return null;
    },

    // Metodo per verificare la validità del form
    checkFormValidity () {
      const valid =
        !!this.customerData.firstName &&
        !!this.customerData.lastName &&
        !!this.customerData.email &&
        !!this.customerData.phone &&
        !!this.customerData.termsAccepted;

      // Emetti un evento per notificare il genitore dello stato di validità
      this.$emit("form-validity-changed", valid);

      return valid;
    },
  },
};
</script>